import { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import PhilosophySection from '../components/PhilosophySection';
import ServicesSection from '../components/ServicesSection';
import LocationsSection from '../components/LocationsSection';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';
import { getContent } from '../lib/api';
import TeamSection from '../components/Team';
import { LazySection } from '../hooks/useFadeIn';
import { useLocation } from 'react-router-dom';
import { PRERENDER } from '../lib/prerender';
import { applyHead, PAGE_META } from '../lib/seo';
import { SITE_DEFAULTS } from '../data/content';

const Home = () => {
  // Skip the intro loader when prerendering so the dump captures the real page.
  const [loading, setLoading] = useState(!PRERENDER);

  // Keep the homepage title/canonical correct on SPA navigation back to '/'.
  useEffect(() => applyHead(PAGE_META['/']), []);
  const [isContactOpen, setIsContactOpen] = useState(false);
  // Lazy init so content is available immediately (no null flicker for team/hero/etc.)
  const [content, setContent] = useState(() => getContent());

  useEffect(() => {
    const reload = () => setContent(getContent());
    reload();
    window.addEventListener('storage', reload);
    const t = setTimeout(() => setLoading(false), 2200);
    return () => {
      window.removeEventListener('storage', reload);
      clearTimeout(t);
    };
  }, []);

  const openContact = () => setIsContactOpen(true);
  const closeContact = () => setIsContactOpen(false);
  const team = Array.isArray(content.team) && content.team.length > 0 ? content.team : SITE_DEFAULTS.team;
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Small delay to let React finish rendering
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);
  return (
    <div className="App">
      {loading && (
        <div className="loader">
          <div className="loader__wordmark">BROCODE</div>
          <div className="loader__sub">BARBERSHOP</div>
          <div className="loader__bar"><div className="loader__fill" /></div>
        </div>
      )}

      <Navigation onContactClick={openContact} />
      <Hero onBookClick={openContact} heroContent={content?.hero} teamCount={team.length} />
      <ContactModal isOpen={isContactOpen} onClose={closeContact} bookingUrl={content?.hero?.bookingUrl} />
      <AboutSection onContactClick={openContact} aboutContent={content?.about} />
      <LazySection rootMargin="300px 0px">
        <PhilosophySection />
      </LazySection>
      <ServicesSection services={content?.services} />
      <TeamSection teamContent={team} />
      <LocationsSection onContactClick={openContact} locations={content?.locations} />
      <Footer onContactClick={openContact} />
    </div>
  );
};

export default Home;
